module.exports = __webpack_public_path__ + "static/ring-492x328-fe356f06a5239aab049f44320c949730.jpg";